import { render, staticRenderFns } from "./CarroRead.vue?vue&type=template&id=69040b5c&"
import script from "./CarroRead.vue?vue&type=script&lang=js&"
export * from "./CarroRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports